import { MediaData } from '@app/shared/types/player';
import { AudioList } from '@app/shared/ui/molecules/Development';
import { Heading } from '@app/shared/ui/atoms/Common';

interface AudioSectionProps {
  title: string;
  list: MediaData[];
  onClick: (item: MediaData) => void;
}

export const AudioSection = ({ title, list, onClick }: AudioSectionProps) => {
  if (!list.length) return null;

  return (
    <div>
      <Heading level={3} className="mb-3 mt-0 text-xl">
        {title}
      </Heading>
      <AudioList audioList={list} onCardClick={onClick} />
    </div>
  );
};
